/* tslint:disable */
/* eslint-disable */
export enum PatientImageViewType {
  ThumbnailView = 0,
  ListView = 1
}
